import React from "react";

import { formatDate, isDefined } from "../../../lib/utils";
import { Flex } from "../../../styles/utility-components";

type DateProps = {
  value?: Date;
  label?: string;
  formatFn?: () => string;
};

export default function DisplayDate({ value, label, formatFn }: DateProps) {
  if (!isDefined(value) && !isDefined(formatFn)) {
    return null;
  }

  const formattedDate = formatFn ? formatFn() : formatDate(value);

  return (
    <Flex>
      {label} {formattedDate}
    </Flex>
  );
}
